<template>
  <div class="row">
    <div class="col-md-6">
      <div class="panel panel-stretch panel-default">
        <div class="panel-heading">
          <span>
            <i class="mdi mdi-home"></i>
            <template v-if="isBusiness">Vestigingsadres</template>
            <template v-else>Bezoekadres</template>
          </span>
          <a-button v-on:click="handleDifferentPostAddressChanged"
                    v-bind:loading="differentAddressButtonLoading"
                    v-bind:disabled="notCurrentVisitOrEstablishmentCustomerProperty"
                    type="primary"
                    class="fix-button-margin pull-right">
            <template v-if="!differentMailAddress">
              Afwijkend postadres
            </template>
            <template v-else>
              Postadres gelijk aan
              <template v-if="isBusiness">vestigingsadres</template>
              <template v-else>bezoekadres</template>
            </template>
          </a-button>
        </div>
        <div v-if="customerLoaded" class="panel-body visit-address">
          <a-alert
              message="Gewijzigde gegevens in dit veld worden automatisch opgeslagen"
              type="info"
              show-icon
              class="padding-bottom"
          />
          <customer-edit-customer-properties
              v-if="isBusiness"
              ref="customerEditVisitCustomerProperty"
              :key="customerEditVisitCustomerPropertiesComponentKey"
              :customer-prop="customer"
              :editable-address="false"
              :address-type="AddressTypeEnum.ESTABLISHMENT"
              v-on:customer-property-deleted="handleEstablishmentCustomerPropertyDeleted"
              v-on:customer-property-updated="handleEstablishmentCustomerPropertyUpdated"
          />
          <customer-edit-customer-properties
              v-else
              ref="customerEditVisitCustomerProperty"
              :key="customerEditVisitCustomerPropertiesComponentKey"
              :customer-prop="customer"
              :editable-address="false"
              :address-type="AddressTypeEnum.VISIT"
              v-on:customer-property-deleted="handleVisitCustomerPropertyDeleted"
              v-on:customer-property-updated="handleVisitCustomerPropertyUpdated"
              v-on:copy-to-partner="handleCopyVisitToPartner"
          />
        </div>
      </div>
    </div>
    <div v-if="differentMailAddress" id="postal-address" class="col-md-6">
      <div class="panel panel-stretch panel-default">
        <div class="panel-heading">
          <i class="mdi mdi-email"></i> Postadres

        </div>
        <div v-if="customerLoaded" class="panel-body">
          <a-alert
              message="Gewijzigde gegevens in dit veld worden automatisch opgeslagen"
              type="info"
              show-icon
              class="padding-bottom"
          />
          <customer-edit-customer-properties
              ref="customerEditMailCustomerProperty"
              :key="customerEditMailCustomerPropertiesComponentKey"
              :customer-prop="customer"
              :editableAddress="false"
              :address-type="AddressTypeEnum.MAIL"
              v-on:customer-property-deleted="handleMailCustomerPropertyDeleted"
              v-on:customer-property-updated="handleMailCustomerPropertyUpdated"
              v-on:copy-to-partner="handleCopyMailToPartner"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customerPropertyApi from '~/api/customer_property';
import customerApi from '~/api/customer';
import propertyInputComponent from '~/modules/property/components/PropertyInputComponent';
import {CustomerPropertyAddressTypeEnum} from "~/enums";

export default {
  name: "EditCustomerPropertyOverviewComponent",
  components: {
    propertyInputComponent
  },
  props: {
    customerId: {},
  },
  data() {
    return {
      AddressTypeEnum: CustomerPropertyAddressTypeEnum,
      loaded: false,
      differentAddressButtonLoading: false,
      countries: [],
      customer: null,
      customerLoaded: false,
      customerProperty: null,
      activeKey: [],
      createModalVisible: false,
      confirmModalVisible: false,
      copyDataToNewAddress: false,
      property: null,
      postalCode: null,
      number: null,
      numberLetter: null,
      numberAddition: null,
      searchAddressTitle: 'Adres aanmaken',
      address_type: {
        mail: 'Postadres',
        visit: 'Bezoekadres',
        establishment: 'Vestigingsadres',
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      creatingCustomerProperty: false,
      differentMailAddress: null,
      customerEditMailCustomerPropertiesComponentKey: 0,
      customerEditVisitCustomerPropertiesComponentKey: 0,
      currentVisitCustomerProperty: null,
      currentEstablishmentCustomerProperty: null,
      currentMailCustomerProperty: null
    };
  },
  mounted() {
    if (this.customerProp === null && this.customerId === null) {
      throw new Error('Either the customer object or customer id is required.');

    }
    this.initCustomer();
  },
  computed: {
    hasPartner() {
      if (typeof this.customer !== "undefined" && this.customer !== null) {
        return this.customer.has_partner
      }
    },
    isBusiness() {
      if (typeof this.customer !== "undefined" && this.customer !== null) {
        return this.customer.is_business
      }
    },
    notCurrentVisitOrEstablishmentCustomerProperty() {
      return this.isBusiness ? !this.currentEstablishmentCustomerProperty : !this.currentVisitCustomerProperty;
    },
  },
  methods: {
    initCustomer() {
      return new Promise((resolve, reject) => {
        customerApi.find(this.customerId, [
          'current_visit_customer_property',
          'current_mail_customer_property',
          'current_establishment_customer_property'
        ])
            .then(response => {
              this.customer = response.data;
              if (typeof response.data.current_visit_customer_property !== 'undefined') {
                this.currentVisitCustomerProperty = response.data.current_visit_customer_property.data;
              }
              if (typeof response.data.current_mail_customer_property !== 'undefined') {
                this.currentMailCustomerProperty = response.data.current_mail_customer_property.data;
              }
              if (typeof response.data.current_establishment_customer_property !== 'undefined') {
                this.currentEstablishmentCustomerProperty = response.data.current_establishment_customer_property.data;
              }
              resolve(this.customer);
              if (this.hasPartner) {
                this.initPartner()
              }
              this.customerLoaded = true;
              this.checkIfDifferentMailAddress();
            })
            .catch(reject);
      });
    },
    initPartner() {
      customerApi.findPartnerByCustomerId(this.customer.id, ['current_visit_customer_property', 'current_mail_customer_property'])
          .then(response => {
            this.partnerData = response.data;
          }).catch();
    },
    handleCreateCustomerProperty() {
      this.creatingCustomerProperty = true
      if (this.customerProperty.is_current) {
        customerPropertyApi.createAsCurrent(this.customerProperty, this.additionalAddressTypes, this.copyAddressToPartner, this.partnerOwnerPercentage).then((response) => {
              this.creatingCustomerProperty = false
            }
        ).catch(error => {
          if (typeof error.response !== "undefined") {
            let errorResponse = error.response.data;
            if (errorResponse.error && errorResponse.error.errors) {
              for (let attribute in errorResponse.error.errors) {
                let errors = errorResponse.error.errors[attribute];
                errors.forEach(error => {
                  this.$notification['error']({
                    message: 'Er ging iets mis',
                    description: error,
                  });
                })
              }
            }
          }
          this.creatingCustomerProperty = false
          reject();
        })
      } else {
        customerPropertyApi
            .create(this.customerProperty, this.additionalAddressTypes, this.copyAddressToPartner, this.partnerOwnerPercentage).then((response) => {
          this.creatingCustomerProperty = false
        }).catch(error => {
          if (typeof error.response !== "undefined") {
            let errorResponse = error.response.data;
            if (errorResponse.error && errorResponse.error.errors) {
              for (let attribute in errorResponse.error.errors) {
                let errors = errorResponse.error.errors[attribute];
                errors.forEach(error => {
                  this.$notification['error']({
                    message: 'Er ging iets mis',
                    description: error,
                  });
                })
              }
            }
          }
          this.creatingCustomerProperty = false
          reject();
        })
      }
    },
    onCustomerPropertyUpdated(customerProperty) {
      this.customerProperty = customerProperty;
    },
    handlePartnerOwnerPercentageChanged(partnerPercentage) {
      this.partnerOwnerPercentage = partnerPercentage
    },
    handleDifferentPostAddressChanged() {
      this.differentAddressButtonLoading = true;
      this.differentMailAddress = !this.differentMailAddress

      if (!this.differentMailAddress) {
        customerPropertyApi.setCurrentFromTypeToTypeByCustomer(this.customer.id,
            this.isBusiness ? 'establishment' : 'visit', 'mail'
        ).then(response => {
          this.customerEditMailCustomerPropertiesComponentKey += 1;
          this.differentAddressButtonLoading = false;
        }).catch()
      } else {
        customerPropertyApi.unsetCurrentByTypeForCustomer(this.customer.id, 'mail').then(response => {
          this.customerEditMailCustomerPropertiesComponentKey += 1;
          this.differentAddressButtonLoading = false;
        }).catch()
      }
    },
    checkIfDifferentMailAddress() {
      // if no current mail address
      if (typeof this.currentMailCustomerProperty === 'undefined' || this.currentMailCustomerProperty === null) {
        this.differentMailAddress = true;
      }
      // if not Business and no current visit address, but there is a current mail address
      if (!this.isBusiness && (typeof this.currentVisitCustomerProperty === 'undefined' || this.currentVisitCustomerProperty === null)) {
        this.differentMailAddress = true;
      }
      // if Business and no current establishment address
      if (this.isBusiness && (typeof this.currentEstablishmentCustomerProperty === 'undefined' || this.currentEstablishmentCustomerProperty === null)) {
        this.differentMailAddress = true;
      }
      // current visit and mail address exist
      if (this.isBusiness) {
        this.differentMailAddress = this.currentEstablishmentCustomerProperty.property_id !== this.currentMailCustomerProperty.property_id
      } else {
        this.differentMailAddress = this.currentVisitCustomerProperty.property_id !== this.currentMailCustomerProperty.property_id
      }
    },
    handleVisitCustomerPropertyUpdated($event) {
      this.currentVisitCustomerProperty = $event;
      if (!this.differentMailAddress) {
        customerPropertyApi.storeCustomerPropertyAsType(this.currentVisitCustomerProperty.id, this.customer.id, 'mail', true)
      }
    },
    handleEstablishmentCustomerPropertyUpdated($event) {
      this.currentEstablishmentCustomerProperty = $event;
      if (!this.differentMailAddress) {
        customerPropertyApi.storeCustomerPropertyAsType(this.currentEstablishmentCustomerProperty.id, this.customer.id, 'mail', true)
      }
    },
    handleMailCustomerPropertyUpdated($event) {
      this.currentMailCustomerProperty = $event;
      if (!this.differentMailAddress) {
        customerPropertyApi.storeCustomerPropertyAsType(
            this.isBusiness ? this.currentEstablishmentCustomerProperty.id : this.currentVisitCustomerProperty.id,
            this.customer.id, 'mail', true)
      }
    },
    handleCopyVisitToPartner($event) {
      customerPropertyApi.storeCustomerPropertyAsType($event.id, this.partnerData.id, 'visit', true).then(() => {
        return new Promise((resolve, reject) => {
          if (!this.differentMailAddress) {
            this.handleCopyMailToPartner($event).then(resolve).catch(reject);
          } else {
            resolve();
          }
        })
      }).catch().finally(() => {
        this.$refs.customerEditVisitCustomerProperty.copyToPartnerButtonLoading = false;
      })
    },
    handleCopyMailToPartner($event) {
      return customerPropertyApi.storeCustomerPropertyAsType($event.id, this.partnerData.id, 'mail', true).catch().finally(() => {
        if (typeof this.$refs.customerEditMailCustomerProperty !== "undefined") {
          this.$refs.customerEditMailCustomerProperty.copyToPartnerButtonLoading = false;
        }
      })
    },
    handleVisitCustomerPropertyDeleted() {
      this.currentVisitCustomerProperty = null;
      // this.$refs.customerEditVisitCustomerProperty.handleShowCustomerPropertyCreate();
    },
    handleMailCustomerPropertyDeleted() {
      this.currentMailCustomerProperty = null;
      // this.$refs.customerEditMailCustomerProperty.handleShowCustomerPropertyCreate();
    },
    handleEstablishmentCustomerPropertyDeleted() {
      this.currentEstablishmentCustomerProperty = null;
    },
  }
}
</script>
<style scoped>
.create-customer-properties {
  position: relative;
  margin-bottom: 15px;
}

.fix-button-margin {
  margin: -6px;
}

.create-button {
  margin-top: 15px;
}

.address-label {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 500;
}

.padding-bottom {
  margin-bottom: 15px;
}
</style>
